// @material-ui/core
import {
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography
} from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
// theme
import classNames from "classnames";
import PropTypes from "prop-types";
import React, { Component } from "react";
import "../node_modules/animate.css/animate.min.css";
import "./Login.css";
import Logo from "./appBar/CPLLogo";
import SmallLogo from "./appBar/Logo";
import GoogleButton from "./library/button/GoogleButton";
// services
import Caba from "./services/Caba";
import { theme } from "./theme";

const themeColor = "blue";

const styles = theme => ({
  loginTitle: {
    color: "white"
  },
  loginButton: {
    background: theme.palette.custom[themeColor].primary.dark,
    borderRadius: 3,
    border: 0,
    color: theme.palette.custom[themeColor].primary.contrastText,
    boxShadow: "none",
    fontSize: "18px",
    fontWeight: "500",
    textAlign: "center",
    width: "100%",
    padding: "10px",
    animationDelay: "1.6s",
    ...theme.mixins.button
  },
  label: {
    textTransform: "capitalize"
  },
  title: {
    marginBottom: 16,
    fontSize: 14
    // color: "white"
  },
  loginCard: {
    backgroundColor: theme.palette.custom[themeColor].primary.main,
    color: theme.palette.custom[themeColor].primary.contrastText,
    boxShadow: "",
    marginTop: "-150px"
  },
  whiteText: {
    color: "white"
  }
});

class Login extends Component {
  state = {
    redirectToReferrer: false
  };

  responseGoogle = response => {
    console.log("google", response.profileObj);

    if (response.tokenObj) {
      var idToken = response.tokenObj.id_token;
      var profile = response.profileObj;

      Caba.login(idToken, profile)
        .then(response => {
          console.log("caba", response.data);
          console.log("Welcome to CABA!");
          this.props.setLogin(true);
        })
        .catch(error => {
          console.log(error.response);
          this.props.notify("error", "Login", error.response.data.message);
        });
    } else if (response.error) {
      this.props.notify(
        "error",
        "Caba",
        response.error.status,
        response.error.message
      );
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <Grid
        container
        spacing={8}
        className="loginGrid"
        alignItems="center"
        direction="row"
        justify="center">
        <Grid item xs={12} md={4}>
          <Card
            className={classNames(
              "loginCard",
              classes.loginCard,
              "animated",
              "fadeIn"
            )}
            raised>
            <CardContent>
              <div className="loginHeader">
                <SmallLogo
                  fill={theme.palette.custom[themeColor].primary.contrastText}
                  className="animated jackInTheBox"
                />
              </div>
              <div className="loginContent">
                <Typography variant="title" color="inherit" component="h2">
                  Welcome to Caba!
                </Typography>
              </div>
            </CardContent>
            <CardActions>
              <GoogleButton
                clientId={this.props.clientId}
                onLogin={this.responseGoogle}
              />
            </CardActions>
          </Card>
          <Logo
            className="fixed animated fadeIn"
            fill={theme.palette.custom[themeColor].secondary.dark}
          />
        </Grid>
      </Grid>
    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  notify: PropTypes.func.isRequired
};

export default withStyles(styles, { withTheme: true })(Login);



// WEBPACK FOOTER //
// ./src/Login.js